import React from 'react';

import { TaskAccessContext, useResolvedTaskAccess } from './useTaskAccess';

export const TaskAccessProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useResolvedTaskAccess();
  return <TaskAccessContext.Provider value={value}>{children}</TaskAccessContext.Provider>;
};
